import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[disableArrows]'
})
export class DisableArrowsDirective implements OnInit {

    constructor(
        private elementRef: ElementRef<HTMLElement>
    ) {}

    ngOnInit(): void {
        this.elementRef.nativeElement.addEventListener('keydown', function(e) {
            if (e.keyCode === 38 || e.keyCode === 40) {
                e.preventDefault();
            }
        });
    }
}